export default "__VITE_ASSET__7254b8bb__"